import { eventStreamService } from 'core-roblox-utilities';

const { eventTypes } = eventStreamService;
const CROSSDEVICEKEY = 'crossDeviceKey';

const events = {
  showModal: {
    name: 'showModal',
    type: eventTypes.pageLoad,
    context: CROSSDEVICEKEY
  }
};

export { events as default };
